// extracted by mini-css-extract-plugin
export default {"title":"f80a6310c3","inner_title":"f31c4d7c91","charge_btn":"_90865f0645"};